export const validation = {
  titleMaxChar: 200,
  blockTitleMaxChar: 30,
  blockParagraphMaxChar: 100,
  blocks: {
    min: 1,
    max: 6
  }
}